module.exports = __webpack_public_path__ + "img/tmh-tc-ts-235x110.12989887.jpg";